import { render, staticRenderFns } from "./FormExplain.vue?vue&type=template&id=35f24a5f&scoped=true&"
import script from "./FormExplain.vue?vue&type=script&lang=js&"
export * from "./FormExplain.vue?vue&type=script&lang=js&"
import style0 from "./FormExplain.vue?vue&type=style&index=0&id=35f24a5f&scoped=true&lang=css&"
import style1 from "./FormExplain.vue?vue&type=style&index=1&id=35f24a5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f24a5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
